import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class MinUnitWeightOfSolidsGamaSMinCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (MinUnitWeightOfSolidsGamaSMinCalculationMethodModel._instance == null) MinUnitWeightOfSolidsGamaSMinCalculationMethodModel._instance = new MinUnitWeightOfSolidsGamaSMinCalculationMethodModel(authManager);
        return MinUnitWeightOfSolidsGamaSMinCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/min-unit-weight-of-solids-gama-s-min-calculation-methods', 'geo-sections/min-unit-weight-of-solids-gama-s-min-calculation-methods/codelist');

        this.entityName = 'geo-sections.MinUnitWeightOfSolidsGamaSMinCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Min Unit Weight Of Solids Gama S Min Calc Method';
        this.setLabel = 'Min Unit Weight Of Solids Gama S Min Calc Methods';

        this.browser = {
            name: 'default-geo-sections-minunitweightofsolidsgamasmincalculationmethod-browser',
            moduleName: 'default-geo-sections-minunitweightofsolidsgamasmincalculationmethod-browser',
            moduleTitle: 'Min Unit Weight Of Solids Gama S Min Calc Methods',
            moduleStateSlotName: 'default-geo-sections-minunitweightofsolidsgamasmincalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-minunitweightofsolidsgamasmincalculationmethod-editor',
            moduleName: 'default-geo-sections-minunitweightofsolidsgamasmincalculationmethod-editor',
            moduleTitle: 'Min Unit Weight Of Solids Gama S Min Calc Method',
            moduleStateSlotName: 'default-geo-sections-minunitweightofsolidsgamasmincalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
